export default {
  title: 'Ordine n. {{number}}',
  labels: {
    item: '{{count}} articolo',
    item_other: '{{count}} articoli',
  },
  buttons: {
    details: 'Dettagli',
  },
  fulfillment_statuses: {
    created: 'Creato',
    reviewed: 'Esaminato',
    accepted: 'Accettato',
    preparing: 'In preparazione',
    ready: 'Pronto',
    on_delivery: 'In consegna',
    picked: 'Ritirato',
    rejected: 'Rifiutato',
  },
};
